<template>
  <div class="account-white-list-page">
    <a-page-header style="border: 1px solid rgb(235, 237, 240)" title="白名单配置"> </a-page-header>
    <a-alert
      class="tips"
      message="配置账号信息后表示白名单配置的账号产生的行为数据才会推送到对应测试环境配置的地址，且这些账号产生的行为数据不会再往正式环境配置的地址进行推送"
      banner
    />
    <div>
      <a-form-model
        :form="form"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 6 }"
        :rules="rules"
        @submit="handleSubmit"
      >
        <!-- <a-form-model-item label="功能开启(关闭)" required >
          <a-tooltip>
            <template slot="title">
              当功能开启后，消息推送只针对白名单配置的账号进行推送
            </template>
            <a-switch v-model="form.isUsed" default-checked @click="checkStatus" />
          </a-tooltip>
        </a-form-model-item> -->
        <a-form-model-item label="账号信息" required>
          <a-textarea
            v-model="form.whiteList"
            placeholder="多个账号请用“逗号”隔开，需英文符号"
            :auto-size="{ minRows: 4 }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="account-white-list-footer">
      <a-button style="margin-top: 23px;margin-right: 15px" type="primary" @click="handleSubmit"
        >提交</a-button
      >
      <a-button style="margin-top: 23px" @click="back">取消</a-button>
    </div>
  </div>
</template>

<script>
import { addWhiteList, getWhiteListByOrganId, updateWhiteList } from '@/services/modules/my-config';

export default {
  name: 'AccountWhiteList',
  props: ['isShow'],
  data() {
    return {
      form: {
        isUsed: true,
        whiteList: '',
      },
      rules: {
        isUsed: { required: true, message: '', trigger: 'blur' },
      },
    };
  },
  mounted() {
    if (this.isShow) {
      getWhiteListByOrganId().then(res => {
        if (res.success) {
          console.log(res);
          const { result } = res;
          if (result.whiteList) {
            if (result.isUsed === '1') {
              this.form.isUsed = true;
            } else {
              this.form.isUsed = false;
            }
          } else {
            this.form.isUsed = true;
          }
          this.form.whiteList = result.whiteList;
          this.form.id = result.id;
        }
      });
    }
  },
  methods: {
    checkStatus(checked, event) {
      console.log(checked);
      console.log(event);
      const that = this;
      if (checked) {
        this.$confirm({
          title: '提示说明',
          content: '当功能开启后，消息推送只针对白名单配置的账号进行推送，请再次确定!',
          onOk() {
            return new Promise(resolve => {
              that.form.isUsed = checked;
              resolve();
            });
          },
          onCancel() {
            return new Promise(resolve => {
              that.form.isUsed = false;
              resolve();
            });
          },
        });
      }
    },
    handleSubmit() {
      const data = {};
      if (this.form.isUsed || !this.form.whiteList) {
        data.isUsed = '1';
      } else {
        data.isUsed = '0';
      }
      data.whiteList = this.form.whiteList;
      if (this.form.id) {
        data.id = this.form.id;
        updateWhiteList(data).then(res => {
          if (res.success) {
            this.$message.success('更新成功');
            this.$emit('backList');
          } else {
            this.$message.error(res.errorMessage);
          }
        });
      } else {
        addWhiteList(data).then(res => {
          if (res.success) {
            this.$message.success('更新成功');
            this.$emit('backList');
          } else {
            this.$message.error(res.errorMessage);
          }
        });
      }
    },
    back() {
      console.log('1');
      this.$emit('backList');
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  margin: 20px 60px 20px 36px;
  background: none;
}
.account-white-list-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  background: #ffffff;
  .un-developer-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: white;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    border: 1px solid #ccc;
    .content {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 20px;
    }
    .child-div {
      text-align: center;
      align-items: center;
    }
  }
}
.account-white-list-footer {
  height: 80px;
  text-align: center;
}
</style>
